import { useEffect, useState } from 'react';
import styles from './RequestTypeForms.module.scss';
import {
  normalizeInput,
  validateCode,
} from '../../../../components/body/checkout/sections/checkoutUtils';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../../src/app/hooks';
import { submitSupportTicket } from '../../../../src/features/user/userState';
import { validationTypes } from '../../../../commons/validations';
import {
  cleanEmailField,
  cleanNameField,
  phoneNumberLengthValidation,
  processEmailField,
  processNameField,
} from '../../../../commons/formatters';
import {
  removeCountryCodeAndFormat,
  setAutoCompleteFormData,
} from '../../../../commons/utils/utils';
import {
  COMMENTS_REGISTER,
  EMAIL_REGISTER,
  FN_REGISTER,
  LN_REGISTER,
  PHONE_REGISTER,
  ZIP_REGISTER,
} from '../../../../commons/Constants';
import { ContainedButton, TextInput } from '../../../../commons/hoc';
import TextAreaInput from '../../../../commons/hoc/Input/TextAreaInput/TextAreaInput';

const QuestionForm = ({ currentOption, setFormSubmitted = () => {} }) => {
  const dispatch = useAppDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
    trigger,
    getValues,
    setValue,
  } = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const onSubmit = (data) => {
    dispatch(
      submitSupportTicket({
        'qmonitorid': 33,
        'firstname': data.firstName,
        'lastname': data.lastName,
        'phone': removeCountryCodeAndFormat(data.phone, true),
        'email': data.email,
        'Custom[643]': data.zip,
        'message': data.comments,
      })
    );
    setFormSubmitted(true);
  };

  const [phoneNumber, setPhoneNumber] = useState('');
  const [zipCode, setZipCode] = useState('');

  const handleAutoComplete = (e) => {
    if (currentOption === 'question' || currentOption === 'other') {
      let target = e?.target?.form ? Array.from(e.target.form) : [];
      let tempFormData = {};
      target.forEach((item) => {
        if (item.name !== '') {
          tempFormData[item.name] =
            item.name === PHONE_REGISTER
              ? normalizeInput(item.value)
              : item.value;
        }
      });
      setAutoCompleteFormData(getValues(), tempFormData, setValue, trigger);
      setPhoneNumber(getValues().phone);
      setZipCode(getValues().zip);
    }
  };
  useEffect(() => {
    if (typeof window === 'object') {
      import('detect-autofill').then((mod) => {
        window.addEventListener('onautocomplete', handleAutoComplete);
      });
    }
  }, []);

  const firstName = register(FN_REGISTER, {
    ...validationTypes.firstName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(FN_REGISTER, e.target.value);
      clearErrors(FN_REGISTER);
    },
    onBlur: (e) => {
      setValue(FN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const lastName = register(LN_REGISTER, {
    ...validationTypes.lastName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(LN_REGISTER, e.target.value);
      clearErrors(LN_REGISTER);
    },
    onBlur: (e) => {
      setValue(LN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const phone = register(PHONE_REGISTER, {
    ...validationTypes.phone,
    onBlur: (e) => {
      setPhoneNumber(normalizeInput(e.target.value, phoneNumber));
    },
    onChange: (e) => {
      clearErrors(PHONE_REGISTER);
      let number = phoneNumberLengthValidation(e.target.value);
      if (number !== null) {
        setPhoneNumber(number);
      }
    },
  });

  const email = register(EMAIL_REGISTER, {
    ...validationTypes.email,
    onChange: (e) => {
      setValue(EMAIL_REGISTER, processEmailField(e.target.value));
      clearErrors(EMAIL_REGISTER);
    },
    onBlur: (e) => {
      setValue(EMAIL_REGISTER, cleanEmailField(e.target.value));
    },
  });

  const zip = register(ZIP_REGISTER, {
    ...validationTypes.zip,
    onChange: (e) => {
      setValue(ZIP_REGISTER, e.target.value);
      setZipCode(validateCode(e.target.value, zipCode, 5));
      clearErrors(ZIP_REGISTER);
    },
  });

  const comments = register(COMMENTS_REGISTER, validationTypes.comments);

  const handlePhoneNumber = (event) => {
    setPhoneNumber(event.target.value.replace(/\D/g, ''));
  };

  return (
    <div className={styles.supportFormsContainer}>
      <form onSubmit={handleSubmit(onSubmit)} id="form-question">
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="First Name"
              required={validationTypes.firstName.required}
              register={firstName}
              isDarkBorder={true}
              maxLength={validationTypes.firstName.maxLength}
              errors={errors}
              placeholder="First Name"
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Last Name"
              required={validationTypes.lastName.required}
              register={lastName}
              isDarkBorder={true}
              maxLength={validationTypes.lastName.maxLength}
              errors={errors}
              placeholder="Last Name"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              type="tel"
              inputMode="numeric"
              register={phone}
              required={validationTypes.phone.required}
              label="Phone Number"
              placeholder="(XXX) XXX-XXXX"
              isDarkBorder={true}
              onFocus={handlePhoneNumber}
              onClickCapture={handlePhoneNumber}
              errors={errors}
              maxLength={validationTypes.phone.maxLength}
              value={phoneNumber}
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              isDarkBorder={true}
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Zip Code"
              required={validationTypes.zip.required}
              register={zip}
              isDarkBorder={true}
              maxLength={validationTypes.zip.maxLength}
              errors={errors}
              placeholder="Zip Code"
              value={zipCode}
            />
          </div>
        </div>
        <div className={styles.questionsCommentsContainer}>
          <label>
            Comments/Questions
            <div className={styles.fieldRequired}>*</div>
          </label>
          <div className={styles.questionsComments}>
            <TextAreaInput
              className={`${styles.questionTextArea} ${
                errors?.comments?.type ? styles.inputError : ''
              }`}
              id="questionsComments"
              minRows={4}
              onChange={(e) => {
                clearErrors(COMMENTS_REGISTER);
              }}
              register={comments}
              errors={errors}
            />
          </div>
          <div className={styles.sendButtonContainer}>
            <ContainedButton
              btnType="dark"
              className={styles.submitRequestButton}
            >
              Submit Request
            </ContainedButton>
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuestionForm;
